import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { AppId, AttributeReport, Page } from '../../model';
import { buildQuery } from '../../util';
import { Params } from '@angular/router';

interface ArticleNoteUpdate {
  id?: string;
  articleId?: string;
  summary?: string;
}

@Injectable({ providedIn: 'root' })
export class AttributeReportService extends _Service<AttributeReport> {
  constructor() {
    super('api/attribute-report');
  }

  listForCompany = async (companyId: string, queryParams: Params) =>
    this.http.get<Page<AttributeReport>>(`api/company/${companyId}/attribute-report` + buildQuery(queryParams));

  updateNotes = async (reportId: AppId, notes: ArticleNoteUpdate[]) =>
    this.http.put(`api/attribute-report/${reportId}/notes`, notes);

  updateMeta = async (reportId: AppId, payload: { name: string; startDate: string | null; endDate: string | null }) =>
    this.http.put(`api/attribute-report/${reportId}`, payload);

  downloadDoc = async (reportId: AppId) => this.http.getBlob(`api/attribute-report/${reportId}/pdf`);
}
